<template>
<div class="simple-page">
  <HeadNav selectedLanguage="en" page="contact" />
  <main class="doc-page">
    <h1>Contact MyVPNBook</h1>
    <DocBlocks :blocks="blocks" />
  </main>
</div>
</template>

<script>
import '@/css/vpn-theme.scss'
import HeadNav from '@/components/HeadNav.vue'
import DocBlocks from '@/components/myvpnbook/DocBlocks.vue'
import { legalPages } from '@/data/myvpnbookDocPages'

export default {
  name: 'ContactPage',
  components: { HeadNav, DocBlocks },
  data() {
    return { blocks: legalPages.contact }
  },
  mounted() {
    if (typeof document !== 'undefined') document.body.classList.add('vpn-site')
  },
  beforeDestroy() {
    if (typeof document !== 'undefined') document.body.classList.remove('vpn-site')
  },
}
</script>

<style lang="scss" scoped>
.doc-page {
  width: var(--vpn-content-width);
  margin: 0 auto;
  padding: 40px 0 72px;
}

h1 {
  margin: 0 0 16px;
  font-size: clamp(32px, 4vw, 44px);
}
</style>
